import { render, staticRenderFns } from "./IllionFlowController.vue?vue&type=template&id=60d64a16&scoped=true&"
import script from "./IllionFlowController.vue?vue&type=script&lang=js&"
export * from "./IllionFlowController.vue?vue&type=script&lang=js&"
import style0 from "./IllionFlowController.vue?vue&type=style&index=0&id=60d64a16&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d64a16",
  null
  
)

export default component.exports